import React from "react";
import AvatarGroupComponent from "./Avatar.jsx";
import editIcon from '../../assets/images/edit.svg';

export default function StandardCard({
  userCount,
  onClick,
  item,
  title,
  avatars,
}) {
  return (
    <React.Fragment>
      <div
        className="card-item-std p-4 bg-white primary-box-shadow border-round-md cursor-pointer"
        onClick={() => onClick?.(item, "cardDetails")}
      >
        <div className="flex flex-column">
          <div className="flex pb-3 h-3rem">
            <div className="flex align-items-center text-primaryColor public_sans_400 text-15px">
              {"Total " + userCount + " users"}
            </div>
            <div className="ml-auto">
              {/* {item?.users?.length && ( */}
                <AvatarGroupComponent
                  count={item?.users?.length}
                  avatars={item?.users}
                />
              {/* )} */}
            </div>
          </div>
          <div className="flex align-items-center justify-content-between">
            <div className="text-justify">
              {title && (
                <div className="text-secondaryTextColor public_sans_500 text-lg pb-2 capitalize">
                  {title}
                </div>
              )}
            </div>
          </div>

          <div className="flex justify-content-between mt-2 md:mt-0">
            <div
              className=" text-secoundaryBlue text-15px public_sans_400 cursor-pointer flex align-items-center"
              onClick={(e) => {
                e.stopPropagation();
                onClick?.(item);
              }}
            >
              <span>Role</span>
              <span>
                <img src={editIcon} alt="editRole" className="pr-2" />
              </span>
            </div>
            <div
              className=" text-secoundaryBlue text-15px public_sans_400 cursor-pointer flex align-items-center"
              onClick={(e) => {
                e.stopPropagation();
                onClick?.(item, "permission");
              }}
            >
              <span>Permissions</span>
              <span>
                <img src={editIcon} alt="editPermission" className="pr-2" />
              </span>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}
